const defs = [
  {
    title: "Avvikelser",
    key: "FAULTS",
    visited: false,
    hasError: false,
    fieldKeys: ["faults"],
  },
  {
    title: "Dokument",
    key: "DOCUMENT",
    visited: true,
    hasError: false,
    fieldKeys: ["completion_files"],
  },
  {
    title: "Granska och slutför",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
];

export default () => {
  return defs;
};
